import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, switchMap, throwError } from 'rxjs';

import { EvaluationAthleteProvider } from '../providers/evaluation-athlete-provider.services';
import { catchError, map } from "rxjs/operators";
import { Organization } from "../../common/models/organization";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";

@Injectable({providedIn: 'root'})
export class EvaluationAthleteResolver implements Resolve<any> {
    constructor(
        private evaluationAthleteProvider: EvaluationAthleteProvider,
        private organizationsProvider: OrganizationsProvider,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
      const code = route.paramMap.get('organizationCode');
      if (!code) throw new Error('Organization code is required');
      return this.organizationsProvider.getByCode(code).pipe(
        switchMap((organization: Organization) => {
          return this.evaluationAthleteProvider.getAthleteEvaluation(organization.id!, +route.params['athleteId'], +route.params['evaluationAthleteId']);
        }),
        catchError((error) => {
          console.error("EvaluationAthleteResolver: ", error);
          return throwError(() => new Error('Failed to retrieve athlete data'));
        }),
      );
    }
}
